import { Component } from '@angular/core';

@Component({
  selector: 'fgb-ace-jump-loaderboard-page',
  templateUrl: './ace-jump-loaderboard-page.component.html',
  styleUrl: './ace-jump-loaderboard-page.component.scss',
})
export class AceJumpLoaderboardPageComponent {
  LeaderboardType = 100;
}
